<script>
  export let row = {};
</script>

<a href={row.url} target="_blank">{row.url}</a>

<style lang="scss">
  a {
    text-decoration: none;
  }
</style>
